<template>
  <div
    class="mr-1 p-1 rounded cursor-pointer relative flex items-center"
    ref="notice"
    @mouseenter="noticeMenu = true"
    @mouseleave="noticeMenu = false"
  >
    <img
      src="@/assets/notice-1.svg"
      class="w-26 h-26"
      alt=""
    />
    <div
      v-show="$store.state.user.noRead>0"
      class="absolute top-0 right-0 w-3.5 h-3.5 leading-none bg-red-500 rounded-full text-xs text-white text-center"
    >
      {{$store.state.user.noRead}}
    </div>
    <div
      v-show="noticeMenu"
      class="dark:bg-darkMenu dark:text-gray-400 topSelect top-10 -right-16 sm:-right-4 w-80 sm:w-96 cursor-default"
    >
      <div class="flex justify-between items-center bg-gray-50 dark:bg-darkMain py-2.5 px-5">
        <div>Notifications</div>
        <div
          @click="readAll"
          class="text-gray-500 text-13 cursor-pointer hover:underline"
        >Mark all as read</div>
      </div>
      <div
        ref="noticePanel"
        v-show="$store.state.user.noticeList.length>0"
        class="h-72 overflow-auto notiList"
      >
        <div
          v-for="(ni,nn) in $store.state.user.noticeList"
          :key="nn"
          class="border-t border-gray-200 dark:border-darkLine py-2.5 px-5 relative hover:bg-tableHover dark:hover:bg-darkLine"
        >
          <div class="flex justify-between text-13">
            <div class="leading-tight">{{ni.msg}}</div>
            <div class="text-gray-500 w-24 flex-shrink-0 text-right">{{ni.created_data}}</div>
          </div>
          <div class="mt-3 flex">
            <div
              @click="viewNotice(ni,nn)"
              class="text-blue-500 hover:underline cursor-pointer"
            >View details</div>
          </div>
          <div
            v-show="ni.is_read == 0"
            class="absolute top-3 left-2 w-2 h-2 bg-red-500 rounded-full"
          ></div>
        </div>
      </div>
      <div
        v-show="$store.state.user.noticeList.length==0"
        class="my-8"
      >
        <img
          src="@/assets/noNotification.svg"
          class="w-28 h-28 mx-auto mb-1"
          alt=""
        >
        <div class="text-center">No notification</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  createCoupons,
  getNotice,
  setNotice,
  getId
} from '@/api/user'
export default {
  data(){
    return {
      noRead: '',
      noticeMenu: false,
      noticeList:[],
      newNotice: ''
    }
  },
  mounted(){
    // this.noticeList = this.$store.state.user.noticeList;
    // this.noRead = this.$store.state.user.noRead;
    this.newNotice = setInterval(() => this.accessNotice(), 60000)
  },
  methods:{
    accessNotice(){
      getNotice().then(res=>{
        if(res.data.msg){
          res.data.is_read = 0
          // this.noRead = Number(this.noRead)+1
          this.$store.commit('ADDNOR')
          let arr = this.$store.state.user.noticeList;
          arr.unshift(res.data)
          // this.noticeList.unshift(res.data)
          this.$store.commit('NOTICE', arr)
        }
      })
    },
    viewNotice(item,index){
      if(this.noRead>0){
        // this.noRead = this.noRead - 1
        this.$store.commit('DECNOR')
      }
      setNotice({
        customer_id: item.customer_id,
        msg_id: item.id,
        type: 1,
      }).then(res=>{
        // this.noticeList[index].is_read = 1
        this.$store.commit('SETREAD', index)

        let num = 0
        for(let n=0;n<this.$store.state.user.noticeList.length;n++){
          if(this.$store.state.user.noticeList[n].is_read == 0){
            num++
          }
        }
        // this.noRead = num
        this.$store.commit('READNUM', num)

        if(item.msg_link == 'super'){
          this.$router.push({name:'memberReview',})
        }else{
          this.$router.replace({
            path:`/order/forwardingOrder/${item.freightOrderId}`
          })
          setTimeout(()=>{
            this.$router.go(0)
          },300)
        }
      })
    },
    readAll(){
      setNotice({
        customer_id: JSON.parse(localStorage.getItem('userId')),
        type: 2,
      }).then(res=>{
        for(let n=0;n<this.$store.state.user.noticeList.length;n++){
          this.$store.state.user.noticeList[n].is_read = 1
        }
        // this.noRead = 0
        this.$store.commit('CLEARREAD')
      })
    },
    noticeSwitch(){      
      this.noticeMenu = !this.noticeMenu
    },
  }
};
</script>

<style>
</style>